import React, { Component } from 'react';
import styled from 'styled-components';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import moment from 'moment';
import LineGraph from '../../../../components/Charts/LineGraph';
import EvolutionIcon from '../../../../components/EvolutionIcon';
import ExportButton from '../../../../components/Export';
import range from 'lodash/range';
import min from 'lodash/min';
import max from 'lodash/max';
import { I18n } from 'react-redux-i18n';

const RecapHistoryCardContainer = styled.div`
  > * {
    height: calc(100% - 60px);
  }

  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .graphContainer {
    margin-bottom: 37px;
  }

  .rhcTooltipContainer {
    min-width: 350px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
    width: 100%;
  }

  .rhcTooltipValues {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 75%;
  }

  .rhcTooltipValues > * {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 33%;
    text-align: center;

    p {
      margin-right: 5px;
    }
  }

  .rhcTooltipValues > div:not(:last-child) {
    margin-right: 15px;
  }

  .rhcDate {
    color: #abb5be;
    text-transform: uppercase;
  }

  .rhcLabel {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
  }

  .recharts-cartesian-axis-ticks {
    font-size: 12px;
  }

  .recharts-yAxis tspan {
    fill: ${(props) => props.theme.colors.dark};
  }
`;

export default class RecapHistoryCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hoverExport: false
    };
  }

  formatData() {
    const data = this.props.data || [];
    return data.map((item) => ({
      name: moment(item.date).locale('fr').format('DD/MM'),

      minPrice: {
        icon: 'negative',
        value: Number(item.min_euro_price).toFixed(1)
      },
      value: { icon: 'neutral', value: Number(item.avg_euro_price).toFixed(1) },
      maxPrice: {
        icon: 'positive',
        value: Number(item.max_euro_price).toFixed(1)
      }
    }));
  }

  renderTooltip(data) {
    return (
      <div>
        <div className="rhcTooltipContainer">
          <p className="rhcDate">
            {I18n.t('primeur.recap.lineGraph.tooltipLabel')} : {data.name}
          </p>
          <div className="rhcTooltipValues">
            <p className="rhcLabel">{I18n.t('lowPrice')}</p>
            <p className="rhcLabel">{I18n.t('averagePrice')}</p>
            <p className="rhcLabel">{I18n.t('highPrice')}</p>
          </div>
        </div>
        <div className="rhcTooltipContainer">
          <div className="rhcTooltipValues">
            {Object.keys(data).map(
              (key) =>
                data[key].value && (
                  <div key={key}>
                    <EvolutionIcon icon={data[key].icon} />
                    <p>
                      {data[key].value.toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                      })}
                    </p>
                  </div>
                )
            )}
          </div>
        </div>
      </div>
    );
  }

  formatLabel() {
    const data = this.props.data || [];
    return data && data.length > 0
      ? [`${I18n.t('averagePrice')} ${data[0].wine_name} ${data[0].vintage}`]
      : [I18n.t('averagePrice')];
  }

  getTicks(data) {
    if (data && data.length > 0) {
      let minValue = min(data.map((item) => item.value.value));
      minValue = minValue - (minValue % 10);
      let maxValue = max(data.map((item) => item.value.value));
      maxValue = maxValue - (maxValue % 10);

      if (minValue >= maxValue - 5) {
        minValue += 5;
        maxValue -= 5;
      }
      return {
        min: minValue - 10,
        max: maxValue + 20,
        range: range(minValue - 10, maxValue + 20, 5)
      };
    }
    return null;
  }

  render() {
    const formattedData = this.formatData();
    const label = this.formatLabel();
    const ticks = this.getTicks(formattedData);

    return (
      <RecapHistoryCardContainer>
        <Card id="graph-recap-price">
          <CardHeader
            title={I18n.t('primeur.recap.lineGraph.title')}
            fontSize="20px"
            iconRight
            rightComponents={
              <ExportButton
                jpg
                pdf
                name="evolution-prix-marche"
                targetElement="#graph-recap-price"
                colors={['#e25d34']}
              />
            }
          />
          <div className="graphContainer">
            <LineGraph
              data={[formattedData]}
              singleLine
              marginsChart={{ right: 80 }}
              height={275}
              xAxisProps={{
                minTickGap: 10,
                interval: 'preserveStartEnd'
              }}
              yAxisProps={{
                scale: 'linear',
                ticks: ticks ? ticks.range : undefined,
                interval: 'preserveEnd',
                domain: ticks ? [ticks.min, ticks.max] : [20, 40],
                width: 60
              }}
              tooltipOffsetLeft={{ x: 200, y: 60 }}
              tooltipContent={(data, index) =>
                this.renderTooltip(data[0][index])
              }
              tooltipOffset={{ x: -100, y: 40 }}
              labels={label}
              colors={['#e25d34']}
            />
          </div>
        </Card>
      </RecapHistoryCardContainer>
    );
  }
}
